import { ChecklistTimelineItem } from './checklist'

export interface TimelineItem {
	_id: string
	created: never
	coachId: string
	patientId: string
	type: string
	data: ChecklistTimelineItem | {}
}
export interface MessageTimelineItemData {
	email?: string
	textBody?: string
	title?: string
	type?: string
	phone?: string
}

export interface TimeLineListState {
	timelineList: Array<TimelineItem>
	count: number
}

export enum TIMELINE_LIST_ACTION_TYPES {
	TIMELINE_LIST_GET = 'TIMELINE_LIST_GET',
	TIMELINE_LIST_GET_MORE = 'TIMELINE_LIST_GET_MORE',
}

interface TimelineGetAction {
	type:
		| TIMELINE_LIST_ACTION_TYPES.TIMELINE_LIST_GET
		| TIMELINE_LIST_ACTION_TYPES.TIMELINE_LIST_GET_MORE
	payload: {
		paginatedResults: Array<TimelineItem>
		totalCount: Array<{ count: number }>
	}
}

export type TimelineActionTypes = TimelineGetAction

export type TimelineByDate = Array<[string, Array<TimelineItem>]>
